module.exports = __webpack_public_path__ + "static/media/Play.f17eeac5.svg";